import { Component, inject } from '@angular/core'
import { AuthenticationService } from '@app/auth-management/authentication.service'
import { IconComponent } from '@everyday-speech/eds-design-system-lib'

@Component({
  selector: 'dropdown-menu',
  imports: [IconComponent],
  templateUrl: './dropdown-menu.component.html',
  styleUrl: './dropdown-menu.component.scss',
  standalone: true,
})
export class DropdownMenuComponent {
  private authenticationService = inject(AuthenticationService)

  isOpen = false

  toggleDropdown() {
    this.isOpen = !this.isOpen
  }

  logout() {
    this.authenticationService.logout()
  }
}
